

















import { computed, defineComponent, PropType } from "@vue/composition-api";
import filesize from "filesize";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { isAudioFile, isPostFileData } from "@/lib/fileHelpers";
import { getMediaDuration } from "@/lib/time";
import { PostFileData } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import LoadingListItem from "@/components/ContentLoadingPlaceholders/components/LoadingListItem.vue";

export default defineComponent({
  name: "PostFileItem",
  components: { BaseIcon, LoadingListItem },
  props: {
    postFile: { type: Object as PropType<PostFileData | ContentFile>, required: true },
  },
  setup(props) {
    const uploadingProgress = computed(() => (isPostFileData(props.postFile) ? props.postFile.uploadProgress : 100));
    const icon = computed(() => (isAudioFile(props.postFile) ? "sci-music-box" : "msr-docs-filled"));
    const description = computed(() =>
      isAudioFile(props.postFile) && props.postFile.duration
        ? getMediaDuration(props.postFile.duration)
        : filesize(props.postFile.size)
    );
    const name = computed(() => (isPostFileData(props.postFile) ? props.postFile.fileName : props.postFile.title));

    return { uploadingProgress, icon, description, name };
  },
});
